import { render, staticRenderFns } from "./QuotaSpecBinding.vue?vue&type=template&id=b781359a&"
import script from "./QuotaSpecBinding.vue?vue&type=script&lang=js&"
export * from "./QuotaSpecBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports